import React, { useRef, useState } from 'react';
import Sidebar from '../../Navigation/Sidebar/Sidebar';
import LoadingSpinner from "../../Loading/component";
import './Productcategory.css';

const CategoryCreateComponent = ({
  formData = { name: '', description: '', image: null },
  imagePreview = '',
  loading = false,
  isFormValid = false,
  onChange = () => {},
  onImageChange = () => {},
  onSubmit = () => {},
  onBack = () => {},
}) => {
  const [dragActive, setDragActive] = useState(false);
  const fileInputRef = useRef(null);

  const handleImageChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      onImageChange(file);
    }
  };

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    
    const file = e.dataTransfer.files?.[0];
    if (file) {
      onImageChange(file);
    }
  };

  const handleRemoveImage = (e) => {
    e.stopPropagation();
    onImageChange(null);
  };

  // Handle input change with proper event propagation
  const handleInputChange = (e) => {
    e.preventDefault();
    onChange(e);
  };

  return (
    <div className="category-create-container">
      <Sidebar />
      
      {loading && (
        <div className="full-page-loader">
          <LoadingSpinner />
        </div>
      )}
      
      <div className="category-create-content">
        <div className="category-create-header">
          <button className="create-back-btn" onClick={onBack} type="button">
            ←
          </button>
          <h1>Create Category</h1>
        </div>

        <div className="category-create-wrapper">
          <div className="category-create-card">
            <form onSubmit={onSubmit}>
              {/* Category Name Field */}
              <div className="create-form-group">
                <label className="create-form-label">
                  Category Name <span className="create-required">*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData?.name || ''}
                  onChange={handleInputChange}
                  placeholder="Eg. Fresh Food, Electronics, Snacks"
                  className="create-form-input"
                  autoComplete="off"
                />
              </div>

              {/* Description Field */}
              <div className="create-form-group">
                <label className="create-form-label">Description (Optional)</label>
                <textarea
                  name="description"
                  value={formData?.description || ''}
                  onChange={handleInputChange}
                  placeholder="Key details about this category"
                  className="create-form-textarea"
                  rows="3"
                  autoComplete="off"
                />
              </div>

              {/* Image Upload Field */}
              <div className="create-form-group">
                <label className="create-form-label">Image</label>
                <div 
                  className={`create-image-upload-area ${dragActive ? 'create-drag-active' : ''}`}
                  onClick={() => fileInputRef.current?.click()}
                  onDragEnter={handleDrag}
                  onDragLeave={handleDrag}
                  onDragOver={handleDrag}
                  onDrop={handleDrop}
                  style={{ cursor: 'pointer' }}
                >
                  <input
                    type="file"
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                    accept="image/*"
                    onChange={handleImageChange}
                  />
                  {imagePreview ? (
                    <div className="create-image-preview-container">
                      <img src={imagePreview} alt="Preview" className="create-image-preview" />
                      <button 
                        type="button"
                        className="create-remove-image-btn"
                        onClick={handleRemoveImage}
                      >
                        ✕
                      </button>
                    </div>
                  ) : (
                    <div className="create-upload-placeholder">
                      <div className="create-upload-icon">📤</div>
                      <p className="create-upload-text">
                        <span className="create-browse-link">Choose file</span> or drag here
                      </p>
                      <p className="create-upload-hint">Png, Jpg, up to 5MB</p>
                    </div>
                  )}
                </div>
              </div>

              <div className="create-form-actions">
                <button 
                  type="submit" 
                  className={`create-category-btn ${isFormValid ? 'create-active' : 'create-disabled'}`}
                  disabled={!isFormValid || loading}
                >
                  {loading ? 'Creating...' : 'Create Category'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryCreateComponent;